import React, { useEffect, useRef } from 'react';
import { FiTrash2 } from 'react-icons/fi';
// import { useAuditorium } from '@/hooks/useAuditorium';
import { useSession } from '@/hooks/useSession';
import { confirm } from '@/lib/confirm';
import toast from 'react-hot-toast';
import { useClient } from 'jsonapi-react';
import { t } from 'i18next';
import { ChatMessage, ChatMessageActions, ChatMessageBody, ChatMessageHeader, ChatMessageInside, ChatMessageText, ChatMessageTitle, ChatMessageWrapper } from '@/components/custom/chat';
import { AvatarWrapper } from '@/components/ui/avatar';
import { Badge } from '@/components/ui/badge';
import { ChatOriginalText } from '@/components/custom/chat/chat';

export function AuditoriumViewCommentCard(props) {
  // const { deleteChat } = useAuditorium();
  const { chat, id, messageChats, setChats } = props;
  const reply = chat['auditorium-message'] ? true : false;
  const bodyReply = chat['auditorium-message']?.body;
  const { session } = useSession();
  const messageCardBodyRef = useRef(null);
  const client = useClient();

  const deleteChat = async () => {
    const { error } = await client.delete(`auditoriums/${id}/auditorium_chat_messages/${chat.id}`);
    const newChatData = messageChats.filter(item => item.id !== chat.id);

    if (error) {
      toast.error(t('toast.errorDeleteMessage'));
    } else {
      setChats(newChatData);
      toast.success(t('toast.successDeleteMessage'));
    }
  };

  const handleDelete = async () => {
    const confirmed = await confirm({
      title: 'Deseja mesmo excluir este comentário?',
      description: 'Esta ação não poderá ser desfeita',
      confirmText: 'Sim',
      cancelText: 'Não'
    });
    if (confirmed) {
      deleteChat();
    }
  };

  useEffect(() => {
    if (messageCardBodyRef.current) {
      messageCardBodyRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });
    }
  }, [chat.body]);

  const isMyChat = () => {
    if (session.user.name === chat.user.name) {
      return true;
    }
  };

  const extractTextFromHTML = html => {
    const tempDivElement = document.createElement('div');
    tempDivElement.innerHTML = html;
    return tempDivElement.textContent || tempDivElement.innerText || '';
  };

  return (
    chat?.user && (
      <ChatMessageWrapper variant={reply ? 'reply' : 'default'}>
        {reply && <ChatOriginalText dangerouslySetInnerHTML={{ __html: bodyReply.length > 50 ? `${extractTextFromHTML(bodyReply).substring(0, 60)}...` : bodyReply }} />}

        <ChatMessage>
          <AvatarWrapper
            size="sm"
            src={chat.user?.image?.url}
            text={chat.user?.name}
          />

          <ChatMessageInside>
            <ChatMessageHeader>
              <ChatMessageTitle title={chat?.user?.name}>{chat?.user?.name}</ChatMessageTitle>
              <Badge
                variant="bright"
                size="xs"
              >
                {chat?.user?.['profile-names']?.[0]}
              </Badge>
            </ChatMessageHeader>
            <ChatMessageBody>
              <ChatMessageText ref={messageCardBodyRef}>{chat?.body}</ChatMessageText>
            </ChatMessageBody>
          </ChatMessageInside>

          {isMyChat() && (
            <ChatMessageActions>
              <FiTrash2
                className="w-4 cursor-pointer text-danger"
                onClick={handleDelete}
              />
            </ChatMessageActions>
          )}
        </ChatMessage>
      </ChatMessageWrapper>
    )
  );
}
